(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cocktailstix-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[id^="CStixBundle-"]');
    sections.forEach(function(section) {
      /* --- Step 1: Bag selection --- */
      var bagCards = section.querySelectorAll('[data-bags]');
      bagCards.forEach(function(card) {
        card.addEventListener('click', function() {
          bagCards.forEach(function(c) { c.classList.remove('is-selected'); });
          card.classList.add('is-selected');
          updateFlavorSections(section);
          updateCTA(section);
        });
      });

      /* --- Step 2: Flavor selection --- */
      section.querySelectorAll('.cstix-bundle__flavor-list').forEach(function(list) {
        list.querySelectorAll('.cstix-bundle__flavor-row').forEach(function(row) {
          row.addEventListener('click', function() {
            list.querySelectorAll('.cstix-bundle__flavor-row').forEach(function(r) {
              r.classList.remove('is-selected');
            });
            row.classList.add('is-selected');
          });
        });
      });

      /* --- Step 3: Purchase option toggle --- */
      var optionCards = section.querySelectorAll('[data-option]');
      optionCards.forEach(function(card) {
        card.addEventListener('click', function() {
          optionCards.forEach(function(c) {
            c.classList.remove('is-selected');
            var radio = c.querySelector('.cstix-bundle__option-radio');
            if (radio) radio.classList.remove('is-checked');
          });
          card.classList.add('is-selected');
          var radio = card.querySelector('.cstix-bundle__option-radio');
          if (radio) radio.classList.add('is-checked');
          updateCTA(section);
        });
      });

      /* --- Frequency pills --- */
      var freqPills = section.querySelectorAll('[data-freq]');
      freqPills.forEach(function(pill) {
        pill.addEventListener('click', function(e) {
          e.stopPropagation();
          freqPills.forEach(function(p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
        });
      });

      /* --- Show/hide flavor sections based on bag count --- */
      function updateFlavorSections(sec) {
        var selected = sec.querySelector('[data-bags].is-selected');
        var count = selected ? parseInt(selected.getAttribute('data-bags')) : 1;
        var flavorSections = sec.querySelectorAll('[data-flavor-section]');
        flavorSections.forEach(function(fs, i) {
          fs.style.display = i < count ? '' : 'none';
        });
      }

      /* --- Update CTA text based on selected option --- */
      function updateCTA(sec) {
        var ctaText = sec.querySelector('[data-cta-text]');
        if (!ctaText) return;
        var isSubscribe = sec.querySelector('[data-option="subscribe"].is-selected');
        if (isSubscribe) {
          ctaText.textContent = 'start subscription \u2014 $xx.xx/delivery';
        } else {
          ctaText.textContent = 'add to cart \u2014 $xx.xx';
        }
      }

      /* Initial state */
      updateFlavorSections(section);
      updateCTA(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocktailstix-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cocktailstix-faq').forEach(function (section) {
      var cards = Array.from(section.querySelectorAll('[data-faq-card]'));

      function toggleCard(card, forceOpen) {
        var btn = card.querySelector('.cocktailstix-faq__question');
        var answerWrap = card.querySelector('.cocktailstix-faq__answer-wrap');
        if (!btn || !answerWrap) return;

        var isOpen = card.classList.contains('is-open');
        var shouldOpen = typeof forceOpen === 'boolean' ? forceOpen : !isOpen;

        if (isOpen && !shouldOpen) {
          answerWrap.style.maxHeight = answerWrap.scrollHeight + 'px';
          requestAnimationFrame(function () {
            answerWrap.style.maxHeight = '0';
          });
          card.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          answerWrap.setAttribute('aria-hidden', 'true');
        } else if (!isOpen && shouldOpen) {
          card.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answerWrap.setAttribute('aria-hidden', 'false');
          answerWrap.style.maxHeight = answerWrap.scrollHeight + 'px';
          answerWrap.addEventListener('transitionend', function handler() {
            if (card.classList.contains('is-open')) {
              answerWrap.style.maxHeight = 'none';
            }
            answerWrap.removeEventListener('transitionend', handler);
          });
        }
      }

      cards.forEach(function (card) {
        var btn = card.querySelector('.cocktailstix-faq__question');
        if (!btn) return;

        btn.addEventListener('click', function () {
          toggleCard(card);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocktailstix-how-to-mix"] && !Shopify.designMode) return;
  try {
    
  /* How to Mix carousel navigation + mobile arrow overlay */
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.cocktailstix-howtomix').forEach(function(section) {
      var track = section.querySelector('.cocktailstix-howtomix__track');
      var nav = section.querySelector('.cocktailstix-howtomix__nav');
      var navRow = section.querySelector('.cocktailstix-howtomix__nav-row');
      var prev = section.querySelector('.cocktailstix-howtomix__nav-btn--prev');
      var next = section.querySelector('.cocktailstix-howtomix__nav-btn--next');
      if (!track || !prev || !next || !nav) return;

      function getCardWidth() {
        var card = track.querySelector('.cocktailstix-howtomix__card');
        if (!card) return 330;
        var style = window.getComputedStyle(track);
        var gap = parseInt(style.columnGap || style.gap, 10) || 10;
        return card.offsetWidth + gap;
      }

      function positionNavMobile() {
        if (window.innerWidth >= 750) {
          if (navRow) navRow.style.cssText = '';
          nav.style.display = '';
          nav.style.position = '';
          nav.style.top = '';
          nav.style.left = '';
          nav.style.right = '';
          nav.style.zIndex = '';
          nav.style.gap = '';
          nav.style.pointerEvents = '';
          prev.style.position = '';
          prev.style.left = '';
          prev.style.pointerEvents = '';
          next.style.position = '';
          next.style.right = '';
          next.style.pointerEvents = '';
          return;
        }
        /* Unhide the nav-row parent so nav can render */
        if (navRow) navRow.style.cssText = 'display:block !important;margin:0;padding:0;height:0;overflow:visible;';
        var card = track.querySelector('.cocktailstix-howtomix__card');
        if (!card) return;
        var photo = card.querySelector('.cocktailstix-howtomix__card-photo');
        if (!photo) return;
        var sectionRect = section.getBoundingClientRect();
        var photoRect = photo.getBoundingClientRect();
        var photoMidY = (photoRect.top - sectionRect.top) + (photoRect.height / 2) - 30;

        section.style.position = 'relative';
        nav.style.display = 'flex';
        nav.style.position = 'absolute';
        nav.style.top = photoMidY + 'px';
        nav.style.left = '0';
        nav.style.right = '0';
        nav.style.zIndex = '10';
        nav.style.gap = '0';
        nav.style.pointerEvents = 'none';

        prev.style.position = 'absolute';
        prev.style.left = '0';
        prev.style.pointerEvents = 'auto';
        next.style.position = 'absolute';
        next.style.right = '0';
        next.style.pointerEvents = 'auto';
      }

      function updateArrows() {
        if (window.innerWidth >= 750) return;
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        prev.style.opacity = atStart ? '0.3' : '1';
        prev.style.pointerEvents = atStart ? 'none' : 'auto';
        next.style.opacity = atEnd ? '0.3' : '1';
        next.style.pointerEvents = atEnd ? 'none' : 'auto';
      }

      positionNavMobile();
      window.addEventListener('resize', positionNavMobile);
      window.addEventListener('load', function() { positionNavMobile(); updateArrows(); });
      track.addEventListener('scroll', updateArrows);

      prev.addEventListener('click', function() {
        track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
      });
      next.addEventListener('click', function() {
        track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocktailstix-love-sip"] && !Shopify.designMode) return;
  try {
    
  /* Carousel navigation — scroll 1 card, overlay arrows on mobile */
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.cocktailstix-lovesip').forEach(function(section) {
      var track = section.querySelector('.cocktailstix-lovesip__track');
      var nav = section.querySelector('.cocktailstix-lovesip__nav');
      var prev = section.querySelector('.cocktailstix-lovesip__nav-btn--prev');
      var next = section.querySelector('.cocktailstix-lovesip__nav-btn--next');
      if (!track || !prev || !next || !nav) return;

      function getCardWidth() {
        var card = track.querySelector('.cocktailstix-lovesip__card');
        if (!card) return 296;
        var style = window.getComputedStyle(track);
        var gap = parseInt(style.columnGap || style.gap, 10) || 16;
        return card.offsetWidth + gap;
      }

      function positionNavMobile() {
        /* Desktop: show/hide in header row */
        if (window.innerWidth >= 750) {
          var needsScroll = track.scrollWidth > track.clientWidth + 2;
          nav.style.display = needsScroll ? 'flex' : 'none';
          nav.style.position = '';
          nav.style.top = '';
          nav.style.left = '';
          nav.style.right = '';
          nav.style.zIndex = '';
          prev.style.position = '';
          prev.style.left = '';
          next.style.position = '';
          next.style.right = '';
          return;
        }
        /* Mobile: overlay arrows on the card track */
        var card = track.querySelector('.cocktailstix-lovesip__card');
        if (!card) return;
        var container = section.querySelector('.cocktailstix-lovesip__container');
        var trackRect = track.getBoundingClientRect();
        var containerRect = container.getBoundingClientRect();
        var cardMidY = (trackRect.top - containerRect.top) + (card.offsetHeight / 2) - 30;

        container.style.position = 'relative';
        nav.style.display = 'flex';
        nav.style.position = 'absolute';
        nav.style.top = cardMidY + 'px';
        nav.style.left = '0';
        nav.style.right = '0';
        nav.style.zIndex = '2';
        nav.style.gap = '0';
        nav.style.pointerEvents = 'none';

        prev.style.position = 'absolute';
        prev.style.left = '0';
        prev.style.pointerEvents = 'auto';
        next.style.position = 'absolute';
        next.style.right = '0';
        next.style.pointerEvents = 'auto';
      }

      function updateArrows() {
        if (window.innerWidth >= 750) return;
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        prev.style.opacity = atStart ? '0.3' : '1';
        prev.style.pointerEvents = atStart ? 'none' : 'auto';
        next.style.opacity = atEnd ? '0.3' : '1';
        next.style.pointerEvents = atEnd ? 'none' : 'auto';
      }

      positionNavMobile();
      window.addEventListener('resize', positionNavMobile);
      /* Re-run after images load to get accurate card height */
      window.addEventListener('load', function() { positionNavMobile(); updateArrows(); });
      track.addEventListener('scroll', updateArrows);

      prev.addEventListener('click', function() {
        track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
      });
      next.addEventListener('click', function() {
        track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocktailstix-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sec = document.querySelector('[data-bundle]');
    if (!sec) return;

    /* Use native fetch saved before Appstle/subscription app scripts override window.fetch */
    var nativeFetch = window.__cstixNativeFetch || window.fetch.bind(window);

    /* ===== VARIANT MAP — Shopify product variant IDs ===== */
    var VARIANTS = {
      'Classic Margarita': 51840310149432,
      'Moscow Mule':       51840310182200,
      'Pineapple Spritz':  51840310214968,
      'Raspberry Martini': 51840310247736,
      'Variety Pack':      51840310280504
    };

    /* ===== PRICING — all dynamic from Shopify + Appstle ===== */
    /* Base price — updated from product JSON at runtime */
    var PRICE_PER_BAG = 39.99;
    /* Selling plans — populated from product JSON */
    var SELLING_PLANS = {};
    var SUB_DISCOUNT = 0;
    var productDataLoaded = false;

    /* Disable CTA until product data loads (prevents race condition with selling plans) */
    var ctaBtnInit = sec.querySelector('[data-bundle-submit]');
    if (ctaBtnInit) { ctaBtnInit.disabled = true; ctaBtnInit.style.opacity = '0.6'; }

    /* Fetch live product data so everything stays in sync with Shopify admin */
    nativeFetch('/products/cocktail-stix.js?v=' + Date.now())
      .then(function(r) { return r.json(); })
      .then(function(prod) {
        /* Live base price */
        PRICE_PER_BAG = prod.price / 100;

        /* Live variant IDs */
        prod.variants.forEach(function(v) {
          VARIANTS[v.title] = v.id;
        });

        /* Map selling plans by frequency */
        (prod.selling_plan_groups || []).forEach(function(g) {
          (g.selling_plans || []).forEach(function(sp, idx) {
            var adj = (sp.price_adjustments || [{}])[0];
            var discPct = (adj.value_type === 'percentage') ? adj.value / 100 : 0;
            /* Detect frequency from option value string */
            var freq = 30 * (idx + 1); /* fallback: 30, 60, 90 */
            var optVal = ((sp.options || [])[0] || {}).value || '';
            var nameVal = (sp.name || '').toLowerCase();
            if (optVal.indexOf('2MONTH') !== -1 || nameVal.indexOf('60') !== -1) freq = 60;
            else if (optVal.indexOf('3MONTH') !== -1 || nameVal.indexOf('90') !== -1) freq = 90;
            else if (optVal.indexOf('1MONTH') !== -1 || nameVal.indexOf('30') !== -1 || nameVal.indexOf('monthly') !== -1) freq = 30;
            SELLING_PLANS[freq] = { id: sp.id, discount: discPct };
          });
        });

        /* Default sub discount from first plan */
        var firstPlan = SELLING_PLANS[30] || SELLING_PLANS[60] || SELLING_PLANS[90];
        if (firstPlan) SUB_DISCOUNT = firstPlan.discount;

        /* Mark data loaded + enable CTA */
        productDataLoaded = true;
        if (ctaBtnInit) { ctaBtnInit.disabled = false; ctaBtnInit.style.opacity = '1'; }

        /* Re-render with live data */
        updatePrices();
      })
      .catch(function(err) {
        console.warn('CStix: Could not load product data', err);
        /* Enable CTA anyway so user can still purchase (one-time fallback) */
        productDataLoaded = true;
        if (ctaBtnInit) { ctaBtnInit.disabled = false; ctaBtnInit.style.opacity = '1'; }
      });

    function getSellingPlanId() {
      var sel = sec.querySelector('[data-freq].is-selected');
      var freq = sel ? parseInt(sel.getAttribute('data-freq')) : 30;
      var plan = SELLING_PLANS[freq] || SELLING_PLANS[30];
      return plan ? plan.id : null;
    }

    function getSubDiscount() {
      var sel = sec.querySelector('[data-freq].is-selected');
      var freq = sel ? parseInt(sel.getAttribute('data-freq')) : 30;
      var plan = SELLING_PLANS[freq] || SELLING_PLANS[30];
      return plan ? plan.discount : SUB_DISCOUNT;
    }

    function getBagCount() {
      var sel = sec.querySelector('[data-bags].is-selected');
      return sel ? parseInt(sel.getAttribute('data-bags')) : 1;
    }

    function isSubscription() {
      return !!sec.querySelector('[data-option="subscribe"].is-selected');
    }

    function getSelectedFlavors() {
      var count = getBagCount();
      var flavors = [];
      sec.querySelectorAll('[data-flavor-section]').forEach(function(fs, i) {
        if (i < count) {
          var trigger = fs.querySelector('[data-flavor-trigger]');
          if (trigger) flavors.push(trigger.getAttribute('data-flavor'));
        }
      });
      return flavors;
    }

    function calcPrices() {
      var count = getBagCount();
      var isSub = isSubscription();
      var bulkDisc = BULK_DISCOUNTS[count] || 0;
      var perBag = PRICE_PER_BAG * (1 - bulkDisc);
      var total = perBag * count;
      if (isSub) {
        var subDiscPct = getSubDiscount();
        var subPerBag = perBag * (1 - subDiscPct);
        var subTotal = subPerBag * count;
        return { total: subTotal, perBag: subPerBag, originalTotal: total, isSub: true, bagCount: count };
      }
      return { total: total, perBag: perBag, originalTotal: PRICE_PER_BAG * count, isSub: false, bagCount: count };
    }

    function fmt(n) { return '$' + n.toFixed(2); }

    /* Bulk discount tiers — read from Shopify automatic discounts */
    var BULK_DISCOUNTS = { 1: 0, 2: 0.10, 3: 0.20 };

    /* ===== UPDATE ALL PRICES ===== */
    function updatePrices() {
      var p = calcPrices();
      var count = getBagCount();
      var subDiscPct = getSubDiscount();

      /* --- Bag cards: update prices dynamically based on purchase type --- */
      var isSub = isSubscription();
      [1, 2, 3].forEach(function(n) {
        var bulkDisc = BULK_DISCOUNTS[n] || 0;
        var bagEach = PRICE_PER_BAG * (1 - bulkDisc);
        if (isSub) bagEach = bagEach * (1 - subDiscPct);
        var bagTotal = bagEach * n;
        var priceEl = sec.querySelector('[data-bag-price="' + n + '"]');
        var eachEl = sec.querySelector('[data-bag-each="' + n + '"]');
        if (priceEl) priceEl.textContent = fmt(bagTotal);
        if (eachEl) eachEl.textContent = fmt(bagEach) + ' each';
      });

      /* --- Subscribe card — base price with selling plan discount --- */
      var subPrice = sec.querySelector('[data-sub-price]');
      var subEach = sec.querySelector('[data-sub-each]');
      var subOrig = sec.querySelector('[data-sub-original]');
      var bulkDisc = BULK_DISCOUNTS[count] || 0;
      var subPerBag = PRICE_PER_BAG * (1 - bulkDisc) * (1 - subDiscPct);
      var subTotal = subPerBag * count;
      if (subPrice) subPrice.textContent = fmt(subTotal);
      if (subEach) subEach.textContent = fmt(subPerBag) + ' each';
      if (subOrig) subOrig.textContent = fmt(PRICE_PER_BAG * count);

      /* --- One-time card — base price with bulk discount --- */
      var otPrice = sec.querySelector('[data-onetime-price]');
      if (otPrice) {
        otPrice.textContent = fmt(PRICE_PER_BAG * (1 - bulkDisc) * count);
      }

      /* --- Dynamic save % labels --- */
      [2, 3].forEach(function(n) {
        var saveEl = sec.querySelector('[data-bag-save="' + n + '"]');
        var disc = BULK_DISCOUNTS[n] || 0;
        if (saveEl && disc > 0) saveEl.textContent = 'save ' + Math.round(disc * 100) + '%';
      });

      /* --- Subscribe title + benefit text --- */
      var subDiscRound = Math.round(subDiscPct * 100);
      var subTitleEl = sec.querySelector('[data-sub-title]');
      if (subTitleEl) subTitleEl.textContent = 'Subscribe & Save ' + subDiscRound + '%';
      sec.querySelectorAll('[data-sub-save-text]').forEach(function(el) {
        el.textContent = 'Save ' + subDiscRound + '% on every order';
      });

      /* --- CTA button --- */
      var ctaText = sec.querySelector('[data-cta-text]');
      if (ctaText) {
        if (p.isSub) {
          ctaText.textContent = 'start subscription \u2014 ' + fmt(p.total) + '/delivery';
        } else {
          ctaText.textContent = 'add to cart \u2014 ' + fmt(p.total);
        }
      }
    }

    /* ===== BAG SELECTION ===== */
    var bagCards = sec.querySelectorAll('.cstix-bundle__bag-card[data-bags]');
    bagCards.forEach(function(card) {
      card.addEventListener('click', function() {
        bagCards.forEach(function(c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        updateFlavorSections();
        updatePrices();
      });
    });

    /* ===== FLAVOR DATA (for JS updates) ===== */
    var FLAVOR_DATA = [
      { name: 'Classic Margarita', desc: 'Bright and citrusy', badges: [{text:'Best Seller',color:'#ffc107'},{text:'Low Stock',color:'#ce3176'}], iconIdx: 0, triggerColor: '#8bc34a' },
      { name: 'Moscow Mule', desc: 'Ginger kick with lime', badges: [{text:'Low Stock',color:'#ce3176'}], iconIdx: 1, triggerColor: '#fab082' },
      { name: 'Pineapple Spritz', desc: 'Tropical and bright', badges: [{text:'New Flavor',color:'#fab082'}], iconIdx: 2, triggerColor: '#ffc107' },
      { name: 'Raspberry Martini', desc: 'Sweet and sophisticated', badges: [{text:'New Flavor',color:'#fab082'}], iconIdx: 3, triggerColor: '#ce3176' },
      { name: 'Variety Pack', desc: 'All 4 flavors included', badges: [{text:'Most Recommended',color:'#8bc34a'}], iconIdx: 4, triggerColor: '#f286ac' }
    ];

    var ICON_IMGS = sec.getAttribute('data-icon-urls').split(',');

    /* ===== FLAVOR DROPDOWN SELECTION ===== */
    function updateTrigger(dropdown, flavorIdx) {
      var trigger = dropdown.querySelector('[data-flavor-trigger]');
      if (!trigger) return;
      var data = FLAVOR_DATA[flavorIdx];
      trigger.setAttribute('data-flavor', data.name);
      trigger.style.background = data.triggerColor;
      var iconEl = trigger.querySelector('.cstix-bundle__flavor-icon');
      iconEl.innerHTML = '<img src="' + ICON_IMGS[flavorIdx] + '" alt="" width="48" height="48" class="cstix-bundle__flavor-icon-img">';
      trigger.querySelector('.cstix-bundle__flavor-name').textContent = data.name;
      trigger.querySelector('.cstix-bundle__flavor-desc').textContent = data.desc;
      var badgesEl = trigger.querySelector('.cstix-bundle__flavor-badges');
      badgesEl.innerHTML = data.badges.map(function(b) { return '<span class="cstix-bundle__flavor-badge" style="background:' + b.color + '">' + b.text + '</span>'; }).join('');
    }

    sec.querySelectorAll('[data-flavor-dropdown]').forEach(function(dropdown) {
      var trigger = dropdown.querySelector('[data-flavor-trigger]');
      var panel = dropdown.querySelector('[data-flavor-panel]');

      /* Toggle dropdown */
      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        var wasOpen = dropdown.classList.contains('is-open');
        /* Close all other dropdowns first */
        sec.querySelectorAll('[data-flavor-dropdown]').forEach(function(dd) { dd.classList.remove('is-open'); });
        if (!wasOpen) dropdown.classList.add('is-open');
      });

      /* Select a flavor from dropdown */
      panel.querySelectorAll('.cstix-bundle__flavor-row').forEach(function(row) {
        row.addEventListener('click', function(e) {
          e.stopPropagation();
          var flavorIdx = parseInt(row.getAttribute('data-flavor-idx'));
          panel.querySelectorAll('.cstix-bundle__flavor-row').forEach(function(r) { r.classList.remove('is-selected'); });
          row.classList.add('is-selected');
          updateTrigger(dropdown, flavorIdx);
          dropdown.classList.remove('is-open');
          /* Gallery swap handled by MutationObserver in the inline script */
        });
      });
    });

    /* Close dropdowns when clicking outside */
    document.addEventListener('click', function() {
      sec.querySelectorAll('[data-flavor-dropdown]').forEach(function(dd) { dd.classList.remove('is-open'); });
    });

    /* ===== PURCHASE OPTION TOGGLE ===== */
    var optionCards = sec.querySelectorAll('[data-option]');
    optionCards.forEach(function(card) {
      card.addEventListener('click', function() {
        optionCards.forEach(function(c) {
          c.classList.remove('is-selected');
          var radio = c.querySelector('.cstix-bundle__option-radio');
          if (radio) radio.classList.remove('is-checked');
        });
        card.classList.add('is-selected');
        var radio = card.querySelector('.cstix-bundle__option-radio');
        if (radio) radio.classList.add('is-checked');
        updatePrices();
      });
    });

    /* ===== FREQUENCY PILLS ===== */
    sec.querySelectorAll('[data-freq]').forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        e.stopPropagation();
        sec.querySelectorAll('[data-freq]').forEach(function(p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
      });
    });

    /* ===== SHOW/HIDE FLAVOR SECTIONS ===== */
    function updateFlavorSections() {
      var count = getBagCount();
      sec.querySelectorAll('[data-flavor-section]').forEach(function(fs, i) {
        fs.style.display = i < count ? '' : 'none';
      });
    }

    /* ===== ADD TO CART ===== */
    var ctaBtn = sec.querySelector('[data-bundle-submit]');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var flavors = getSelectedFlavors();
        var count = getBagCount();

        if (flavors.length < count) {
          alert('Please select a flavor for each bag.');
          return;
        }

        /* Build cart items — clear cart first to avoid conflicts with existing line items */
        var isSub = isSubscription();
        var sellingPlanId = isSub ? getSellingPlanId() : null;
        var items = [];
        flavors.forEach(function(flavor) {
          var variantId = VARIANTS[flavor];
          if (variantId) {
            /* Check if already in items, if so increment qty */
            var existing = items.find(function(it) { return it.id === variantId && it.selling_plan === sellingPlanId; });
            if (existing) {
              existing.quantity += 1;
            } else {
              var item = { id: variantId, quantity: 1 };
              if (sellingPlanId) {
                item.selling_plan = sellingPlanId;
              }
              items.push(item);
            }
          }
        });

        if (items.length === 0) {
          alert('Please select your flavors.');
          return;
        }

        /* Disable button, show loading */
        var ctaTextEl = sec.querySelector('[data-cta-text]');
        var originalText = ctaTextEl ? ctaTextEl.textContent : '';
        ctaBtn.disabled = true;
        ctaBtn.style.opacity = '0.7';
        if (ctaTextEl) ctaTextEl.textContent = 'Adding to cart...';

        /* Reverse so items appear in correct order in cart */
        items.reverse();

        /* Add items ONE AT A TIME to prevent Shopify multi-item selling_plan bug */
        function addItemsSequentially(itemList, idx) {
          if (idx >= itemList.length) {
            /* All items added — verify selling plans then redirect */
            nativeFetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
              var failed = [];
              cart.items.forEach(function(ci) {
                if (isSub && !ci.selling_plan_allocation) {
                  var matchedItem = itemList.find(function(it) { return it.id === ci.variant_id; });
                  if (matchedItem) failed.push(ci);
                }
              });
              if (failed.length) {
                console.warn('CStix: selling_plan missing on', failed.length, 'items — retrying individually');
                /* Remove the broken items and re-add with selling plan */
                var fixes = failed.map(function(ci) {
                  return nativeFetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: ci.key, quantity: 0 })
                  }).then(function() {
                    return nativeFetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ items: [{ id: ci.variant_id, quantity: ci.quantity, selling_plan: sellingPlanId }] })
                    });
                  });
                });
                return Promise.all(fixes);
              }
            }).then(function() {
              if (ctaTextEl) ctaTextEl.textContent = 'Added!';
              /* Get cart drawer section IDs so we can fetch rendered HTML */
              var sectionIds = [];
              document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el) {
                if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
              });
              /* Fetch current page with ?sections= to get rendered cart drawer HTML */
              if (sectionIds.length) {
                return nativeFetch(window.location.pathname + '?sections=' + sectionIds.join(','))
                  .then(function(r) { return r.json(); })
                  .then(function(sectionsData) {
                    /* Dispatch cart:update with sections HTML — theme morphs drawer content */
                    document.dispatchEvent(new CustomEvent('cart:update', {
                      bubbles: true,
                      detail: { resource: {}, sourceId: 'cstix-bundle', data: { source: 'cstix-bundle', itemCount: itemList.length, sections: sectionsData } }
                    }));
                    /* Open drawer after morph completes */
                    setTimeout(function() {
                      var cartDrawer = document.querySelector('cart-drawer-component');
                      if (cartDrawer) {
                        var dialog = cartDrawer.querySelector('dialog');
                        if (!dialog || !dialog.open) {
                          if (cartDrawer.open) cartDrawer.open();
                          else if (cartDrawer.showDialog) cartDrawer.showDialog();
                        }
                      }
                    }, 150);
                  });
              } else {
                /* No cart drawer found — redirect to cart page */
                window.location.href = '/cart';
              }
            }).then(function() {
              /* Reset button */
              setTimeout(function() {
                if (ctaTextEl) ctaTextEl.textContent = originalText;
                ctaBtn.disabled = false;
                ctaBtn.style.opacity = '1';
              }, 1500);
            }).catch(function() {
              /* Fallback: redirect to cart */
              window.location.href = '/cart';
            });
            return;
          }

          var item = itemList[idx];
          nativeFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          })
          .then(function(res) {
            if (!res.ok) throw new Error('Cart error for variant ' + item.id);
            return res.json();
          })
          .then(function() {
            addItemsSequentially(itemList, idx + 1);
          })
          .catch(function(err) {
            console.error('Add to cart failed:', err);
            if (ctaTextEl) ctaTextEl.textContent = originalText;
            ctaBtn.disabled = false;
            ctaBtn.style.opacity = '1';
            alert('Something went wrong. Please try again.');
          });
        }

        addItemsSequentially(items, 0);
      });
    }

    /* Reset button when user navigates back from cart */
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) {
        var btn = document.querySelector('[data-bundle-submit]');
        var txt = btn ? btn.querySelector('[data-cta-text]') : null;
        if (btn) { btn.disabled = false; btn.style.opacity = '1'; }
        if (txt && txt.textContent.indexOf('Added') !== -1) {
          txt.textContent = txt.textContent.replace(/Added.*/, 'start subscription');
        }
      }
    });

    /* ===== GALLERY CAROUSEL ===== */
    var thumbBtns = document.querySelectorAll('.cstix-pdp-hero__thumb-btn');
    var mainImg = document.querySelector('[data-gallery-main]');
    thumbBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        thumbBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var fullSrc = btn.getAttribute('data-full');
        if (mainImg && fullSrc) mainImg.src = fullSrc;
      });
    });
    /* Thumbnail nav arrows */
    var thumbTrack = document.querySelector('.cstix-pdp-hero__thumbs-track');
    var prevNav = document.querySelector('.cstix-pdp-hero__thumb-nav--prev');
    var nextNav = document.querySelector('.cstix-pdp-hero__thumb-nav--next');
    if (thumbTrack && prevNav && nextNav) {
      var scrollAmt = 90;
      prevNav.addEventListener('click', function() { thumbTrack.scrollBy({ left: -scrollAmt, behavior: 'smooth' }); });
      nextNav.addEventListener('click', function() { thumbTrack.scrollBy({ left: scrollAmt, behavior: 'smooth' }); });
    }

    /* ===== INIT ===== */
    updateFlavorSections();
    updatePrices();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocktailstix-social-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[id^="CStixSocialProof-"]');
    if (!section) return;

    var carousel = section.querySelector('[data-carousel="reviews"]');
    if (!carousel) return;

    var cards = carousel.querySelectorAll('.cocktailstix-reviews__card');
    if (cards.length < 2) return;

    var prevBtn = section.querySelector('.cocktailstix-reviews__nav-btn--prev');
    var nextBtn = section.querySelector('.cocktailstix-reviews__nav-btn--next');
    var index = 0;

    function getCardWidth() {
      var card = cards[0];
      var style = window.getComputedStyle(carousel);
      var gap = parseInt(style.gap) || 20;
      return card.offsetWidth + gap;
    }

    function getMaxIndex() {
      var wrapWidth = carousel.parentElement.offsetWidth;
      var totalWidth = cards.length * getCardWidth() - (parseInt(window.getComputedStyle(carousel).gap) || 20);
      var maxScroll = totalWidth - wrapWidth;
      if (maxScroll <= 0) return 0;
      return Math.ceil(maxScroll / getCardWidth());
    }

    function slide(dir) {
      var maxIdx = getMaxIndex();
      if (dir === 'next') {
        index = index < maxIdx ? index + 1 : 0;
      } else {
        index = index > 0 ? index - 1 : maxIdx;
      }
      var offset = index * getCardWidth();
      carousel.style.transform = 'translateX(-' + offset + 'px)';
    }

    function scrollMobile(dir) {
      var cw = getCardWidth();
      carousel.scrollBy({ left: dir === 'next' ? cw : -cw, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (window.innerWidth < 750) { scrollMobile('prev'); } else { slide('prev'); }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (window.innerWidth < 750) { scrollMobile('next'); } else { slide('next'); }
      });
    }

    /* Touch / swipe support */
    var startX = 0;
    var isDragging = false;

    carousel.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    carousel.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      isDragging = false;
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        slide(diff > 0 ? 'next' : 'prev');
      }
    }, { passive: true });

    /* --- Mobile: overlay nav arrows on review card image --- */
    var navBtns = section.querySelector('.cocktailstix-reviews__nav-buttons');

    function positionReviewNavMobile() {
      if (!navBtns) return;
      if (window.innerWidth >= 750) {
        navBtns.style.cssText = '';
        if (prevBtn) { prevBtn.style.cssText = ''; }
        if (nextBtn) { nextBtn.style.cssText = ''; }
        return;
      }
      var card = carousel.querySelector('.cocktailstix-reviews__card');
      if (!card) return;
      var img = card.querySelector('.cocktailstix-reviews__card-image');
      if (!img) return;
      var sectionRect = section.getBoundingClientRect();
      var imgRect = img.getBoundingClientRect();
      var imgMidY = (imgRect.top - sectionRect.top) + (imgRect.height / 2) - 30;

      section.style.position = 'relative';
      navBtns.style.cssText = 'display:flex !important;position:absolute;top:' + imgMidY + 'px;left:0;right:0;z-index:10;gap:0;pointer-events:none;';
      if (prevBtn) {
        prevBtn.style.cssText = 'position:absolute;left:0;pointer-events:auto;width:60px;height:60px;border-radius:30px;background:#8bc34a;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 3.33px 0 #010101;padding:0;';
      }
      if (nextBtn) {
        nextBtn.style.cssText = 'position:absolute;right:0;pointer-events:auto;width:60px;height:60px;border-radius:30px;background:#8bc34a;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 3.33px 0 #010101;padding:0;';
      }
    }

    /* Boundary-aware arrow state for review carousel */
    function updateReviewArrows() {
      if (window.innerWidth >= 750 || !prevBtn || !nextBtn) return;
      var atStart = carousel.scrollLeft <= 1;
      var atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 1;
      prevBtn.style.opacity = atStart ? '0.3' : '1';
      prevBtn.style.pointerEvents = atStart ? 'none' : 'auto';
      nextBtn.style.opacity = atEnd ? '0.3' : '1';
      nextBtn.style.pointerEvents = atEnd ? 'none' : 'auto';
    }
    carousel.addEventListener('scroll', updateReviewArrows);

    positionReviewNavMobile();
    window.addEventListener('load', function() { positionReviewNavMobile(); updateReviewArrows(); });

    /* Recalculate on resize */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        positionReviewNavMobile();
        updateReviewArrows();
        if (window.innerWidth >= 750) {
          var maxIdx = getMaxIndex();
          if (index > maxIdx) index = maxIdx;
          var offset = index * getCardWidth();
          carousel.style.transform = 'translateX(-' + offset + 'px)';
        }
      }, 150);
    });

    /* --- UGC video: show first frame as preview --- */
    var ugcCards = section.querySelectorAll('.cocktailstix-reviews__ugc-card');
    ugcCards.forEach(function(card) {
      var video = card.querySelector('.cocktailstix-reviews__ugc-video');
      if (video) {
        video.addEventListener('loadedmetadata', function() {
          video.currentTime = 0.1;
        }, { once: true });
      }
    });

    /* --- UGC video play/pause --- */
    ugcCards.forEach(function(card) {
      var playBtn = card.querySelector('.cocktailstix-reviews__ugc-play');
      var video = card.querySelector('.cocktailstix-reviews__ugc-video');
      if (playBtn && video) {
        playBtn.addEventListener('click', function() {
          if (video.paused) {
            // Pause and mute all other videos first
            section.querySelectorAll('.cocktailstix-reviews__ugc-video').forEach(function(v) {
              if (v !== video) {
                v.pause();
                v.muted = true;
                var otherBtn = v.closest('.cocktailstix-reviews__ugc-card').querySelector('.cocktailstix-reviews__ugc-play');
                if (otherBtn) otherBtn.style.opacity = '1';
              }
            });
            video.muted = false;
            video.play();
            playBtn.style.opacity = '0';
          } else {
            video.pause();
            video.muted = true;
            playBtn.style.opacity = '1';
          }
        });
        video.addEventListener('click', function() {
          if (!video.paused) {
            video.pause();
            video.muted = true;
            playBtn.style.opacity = '1';
          }
        });
      }
    });

    /* --- UGC row scroll nav --- */
    var ugcRow = section.querySelector('.cocktailstix-reviews__ugc-row');
    var ugcPrev = section.querySelector('.cocktailstix-reviews__ugc-nav-btn--prev');
    var ugcNext = section.querySelector('.cocktailstix-reviews__ugc-nav-btn--next');

    var ugcNav = section.querySelector('.cocktailstix-reviews__ugc-nav');

    if (ugcRow && ugcPrev && ugcNext) {
      var ugcCard = ugcRow.querySelector('.cocktailstix-reviews__ugc-card');
      function getUgcScrollAmount() {
        if (!ugcCard) return 300;
        var gap = parseInt(window.getComputedStyle(ugcRow).gap) || 20;
        return ugcCard.offsetWidth + gap;
      }
      ugcPrev.addEventListener('click', function () {
        ugcRow.scrollBy({ left: -getUgcScrollAmount(), behavior: 'smooth' });
      });
      ugcNext.addEventListener('click', function () {
        ugcRow.scrollBy({ left: getUgcScrollAmount(), behavior: 'smooth' });
      });

      /* Mobile: overlay UGC nav on UGC cards */
      function positionUgcNavMobile() {
        if (!ugcNav) return;
        if (window.innerWidth >= 750) {
          ugcNav.style.cssText = '';
          ugcPrev.style.cssText = '';
          ugcNext.style.cssText = '';
          return;
        }
        var card = ugcRow.querySelector('.cocktailstix-reviews__ugc-card');
        if (!card) return;
        var sectionRect = section.getBoundingClientRect();
        var cardRect = card.getBoundingClientRect();
        var cardMidY = (cardRect.top - sectionRect.top) + (cardRect.height / 2) - 30;

        section.style.position = 'relative';
        ugcNav.style.cssText = 'display:flex !important;position:absolute;top:' + cardMidY + 'px;left:0;right:0;z-index:10;gap:0;pointer-events:none;';
        ugcPrev.style.cssText = 'position:absolute;left:0;pointer-events:auto;width:60px;height:60px;border-radius:30px;background:#8bc34a;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 3.33px 0 #010101;padding:0;';
        ugcNext.style.cssText = 'position:absolute;right:0;pointer-events:auto;width:60px;height:60px;border-radius:30px;background:#8bc34a;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 3.33px 0 #010101;padding:0;';
      }

      /* Boundary-aware arrow state for UGC row */
      function updateUgcArrows() {
        if (window.innerWidth >= 750) return;
        var atStart = ugcRow.scrollLeft <= 1;
        var atEnd = ugcRow.scrollLeft + ugcRow.clientWidth >= ugcRow.scrollWidth - 1;
        ugcPrev.style.opacity = atStart ? '0.3' : '1';
        ugcPrev.style.pointerEvents = atStart ? 'none' : 'auto';
        ugcNext.style.opacity = atEnd ? '0.3' : '1';
        ugcNext.style.pointerEvents = atEnd ? 'none' : 'auto';
      }
      ugcRow.addEventListener('scroll', updateUgcArrows);

      positionUgcNavMobile();
      window.addEventListener('load', function() { positionUgcNavMobile(); updateUgcArrows(); });
      window.addEventListener('resize', function () {
        positionUgcNavMobile();
        updateUgcArrows();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
